<template>
	<div class="relative w-full py-10 px-10">
		<div class="relative w-full flex flex-col justify-center items-start gap-4 z-20">
			<span class="text-xl md:text-2xl lg:text-3xl font-display font-semibold text-brown">
				{{ $t('aboutPage.title') }}
			</span>

			<p class="text-md md:text-lg text-brown">
				{{ $t('aboutPage.text') }}
			</p>

			<div class="w-full flex flex-wrap gap-2">
				<div
					v-for="service in services"
					:key="service"
					class="flex w-fit justify-start items-center gap-2 rounded p-1 md:p-2 pr-3 md:pr-4 border border-green"
				>
					<component :is="service.icon" :width="20" :height="20" color="#3C2B05" class="scale-[0.8] md:scale-[1]"/>
					<span class="text-xs md:text-sm font-normal text-brown">
						{{ $t(service.name) }}
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { services } from '@/assets/config/infoConfig';

export default {
	name: 'AboutPage',
	setup() {
		return {
			services,
		};
	},
};
</script>
